if (!customElements.get('testimonial-slider')) {
  class TestimonialSlider extends HTMLElement {
    constructor() {
      super();

      this.click = false;
      this.$navItems = this.querySelectorAll('.slider-nav__item');
      this.$playPause = this.querySelector('.slider__pause');      
      this.$slides = this.querySelectorAll('.testimonial-slider__slide');
      this.paused = false;
      this.loaded = false;
      this.count = this.$slides.length;

      this.$navItems.forEach($elm => {
        $elm.addEventListener('click', this.onNavClick.bind(this));
      });

      this.initSlider();

      this.navActiveClass = 'js-slider-nav-active';      

      this.$playPause.addEventListener( 'click', (event) => {
        if( this.paused ){
          this.playSlider();
        }else{
          this.pauseSlider();
        }
      });


    }

    pauseSlider() {
      this.$slider.pause();
      this.$playPause.setAttribute('aria-pressed', true);
      this.paused = true;
    }

    playSlider() {      
        this.$slider.play();
        this.$playPause.setAttribute('aria-pressed', false);
        this.paused = false;
    }

    initSlider() {
      const autoplay = this.hasAttribute('data-autoplay') && this.hasAttribute('data-speed') ? this.getAttribute('data-speed') : false;

      let $slider = new Glide(this, {
        type: 'carousel',
        autoplay: autoplay,
        hoverpause: false,
        keyboard: false
      });

      var self = this;
      $slider.on('run.before', function(e){
        const navCount = self.$navItems.length - 1;
        const dir = e.direction == ">" ? 1 : -1; 
        let index = $slider.index + dir;
        if( navCount == $slider.index && e.direction == ">" ){
          index = 0
        }else if( $slider.index == 0 && e.direction == "<" ){
          index = navCount;          
        } 

        if( !self.click ){
          self.setActiveSlide(index);          
        }
      });

      $slider.on('run.after', function(){
        self.setTabableElements( $slider.index );
      });

      $slider.on('mount.after', function(){
        self.setTabableElements( $slider.index );
      });

      $slider.mount();

      this.addEventListener('focusin', function( e ){
        if( e.target !== this.$playPause ){
          this.pauseSlider();
        }
      });

      this.addEventListener('keydown', function( e ){
        const curIndex = $slider.index;

        let nextIndex = false;
        if( e.key === "ArrowRight" ){
          if( curIndex === this.count - 1 ){
            nextIndex = 0;
          }else{
            nextIndex = curIndex + 1;            
          }
          nextIndex = curIndex === ( this.count - 1 ) ? 0 : curIndex + 1; 
        }else if( e.key === "ArrowLeft" ){
          nextIndex = curIndex === 0 ? ( this.count - 1 ) : curIndex - 1; 
        }

        if( nextIndex || nextIndex === 0 ){  
          this.click = true;
          this.setActiveSlide(nextIndex);
          this.click = false;
        }
      });

      this.loaded = true;

      this.$slider = $slider;
    }

    setTabableElements( currentSlideIndex = false ) {
      if( !this.loaded ){
          const $clones = this.querySelectorAll('.glide__slide--clone');
          $clones.forEach( $clone => {
            $clone.setAttribute('aria-hidden', true);
            $clone.setAttribute('tabindex', -1);

            const $tab_items = $clone.querySelectorAll('a, button');
            $tab_items.forEach( $item => {
              $item.setAttribute('tabindex', -1);
              $item.setAttribute('aria-hidden', true);              
            });
          });
      }

      this.$slides.forEach( ($slide, index) => {
        const $tab_items = $slide.querySelectorAll('a, button');

        if( index == currentSlideIndex ){
          $slide.setAttribute('tabindex', 0);
          $slide.setAttribute('aria-hidden', false);
        }else{
          $slide.setAttribute('tabindex', -1);
          $slide.setAttribute('aria-hidden', true);
        }

        $tab_items.forEach( $item => {
          if( index == currentSlideIndex ){
            $item.setAttribute('tabindex', 0);
            $item.setAttribute('aria-hidden', false);
          }else{
            $item.setAttribute('tabindex', -1);
            $item.setAttribute('aria-hidden', true);
          }
        });

      }); 
    }

    onNavClick(e) {
      this.click = true;

      const $elm = e.target;
      const itr = $elm.getAttribute('rel');
      this.setActiveSlide(itr);

      this.click = false;
    }

    setActiveSlide(itr) {
      this.resetNavItems();
      this.setActiveNavItem(itr);
      this.$slider.go(`=${itr}`);
    }

    setActiveNavItem(itr){
      this
        .$navItems[itr]
        .classList
        .add(this.navActiveClass);
    }

    resetNavItems(){
      this.$navItems.forEach($elm => {
        $elm.classList.remove(this.navActiveClass);
      });            
    }
  }

  customElements.define('testimonial-slider', TestimonialSlider);
}